export const environment = {
  production: false,
  baseAPIURL: 'https://m4qb7a5be0.execute-api.us-west-2.amazonaws.com/dev/fvm',
  //baseAPIURL: 'http://localhost:9100/fvm',
  TENANT_ID: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
  CLIENT_ID: '31792d4f-74dd-4055-a89f-27256b0ab2d6',
  REDIRECT_URL: 'https://dev.fvm.toyota.com',
  FVM_HOME_URL: 'https://dev.fvm.toyota.com'
  // REDIRECT_URL: 'http://localhost:4200',
  // FVM_HOME_URL: 'http://localhost:4200/home',

};